import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SendTimeExtensionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"send_time_extension"}/>
}
